import React from 'react'
import styled from 'styled-components'

const HideDuplicatesControl = ({ checked = false, count = 0, hint, onChange }) => (
  <Wrap>
    <Chip type='button' role='switch' aria-checked={checked} $on={checked} onClick={onChange}>
      <Track $on={checked}>
        <Knob $on={checked} />
      </Track>
      <Text>Hide duplicates</Text>
      {count > 0 && (
        <Count
          $on={checked}
          title={`${count.toLocaleString('en-GB')} duplicate copies would be hidden (this counts individual extra copies, not duplicate groups)`}
        >
          {count.toLocaleString('en-GB')}
        </Count>
      )}
    </Chip>
    {hint && <Hint>{hint}</Hint>}
  </Wrap>
)

export default HideDuplicatesControl

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
`

const Chip = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 7px 12px 7px 10px;
  border: 1px solid ${({ $on }) => ($on ? '#9fdbe1' : '#d7dbe0')};
  background: ${({ $on }) => ($on ? '#f0fbfc' : '#ffffff')};
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 150ms ease, border-color 150ms ease;

  &:hover { background: ${({ $on }) => ($on ? '#e7f7f9' : '#f7f9fa')}; }
  &:focus-visible { outline: 2px solid #33becc; outline-offset: 2px; }
`

const Track = styled.span`
  position: relative;
  flex-shrink: 0;
  width: 34px;
  height: 19px;
  border-radius: 999px;
  background: ${({ $on }) => ($on ? '#33becc' : '#cbd5e1')};
  transition: background-color 150ms ease;
`

const Knob = styled.span`
  position: absolute;
  top: 2px;
  left: 2px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 2px rgba(12, 18, 41, 0.25);
  transition: transform 150ms ease;
  transform: translateX(${({ $on }) => ($on ? '15px' : '0')});
`

const Text = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #2c2c2c;
  white-space: nowrap;
`

const Count = styled.span`
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  padding: 3px 7px;
  border-radius: 999px;
  background: ${({ $on }) => ($on ? '#d6f2f5' : '#eef2f5')};
  color: ${({ $on }) => ($on ? '#0f6f78' : '#475569')};
`

const Hint = styled.span`
  font-size: 11.5px;
  color: #6b7280;
  line-height: 1.35;
`
